import { render, staticRenderFns } from "./ParcelDetailHeader.vue?vue&type=template&id=7cdef0d1&scoped=true&"
import script from "./ParcelDetailHeader.vue?vue&type=script&lang=js&"
export * from "./ParcelDetailHeader.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetailHeader.vue?vue&type=style&index=0&id=7cdef0d1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdef0d1",
  null
  
)

export default component.exports